import React from 'react';
import { Reveal } from './Reveal';
import { Eyebrow } from './Eyebrow';
import { testimonials } from '../data/testimonials';
export function TestimonialsSection() {
  return <section className="bg-brand-alt px-5 py-16 md:py-24" data-id="element-153" data-mp="1n00mlqoy8fpc">
      <Reveal className="mx-auto max-w-[1100px]" data-id="element-154" data-mp="1mziu955eqlmp">
        <div className="mb-12 text-center" data-id="element-155" data-mp="1r1dwcbv5x31j">
          <Eyebrow data-id="element-156" data-mp="1r02qm6i5pl7s">Beliebt bei Lehrkräften</Eyebrow>
          <h2 className="mt-5 text-3xl font-extrabold text-brand-navy md:text-4xl" data-id="element-157" data-mp="1d24e76nebyux">
            Was Musiklehrkräfte sagen
          </h2>
        </div>
        <div className="grid items-stretch gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-158" data-mp="1i2inst4nbgv2">
          {testimonials.map((_, index) => <article key={index} className="flex h-full min-h-[200px] flex-col justify-between rounded-xl border border-brand-line bg-brand-main p-7 shadow-sm" data-id="element-159" data-mp="143j13r0p1c1j" data-mpi={index}>
              <div className="space-y-3" aria-hidden="true" data-id="element-160" data-mp="32gsqz8zwfith">
                <span className="block h-3 w-full rounded-full bg-brand-line" data-id="element-161" data-mp="32g989q2fcqee" />
                <span className="block h-3 w-11/12 rounded-full bg-brand-line" data-id="element-162" data-mp="2v0j51mgzhyy7" />
                <span className="block h-3 w-2/3 rounded-full bg-brand-line" data-id="element-163" data-mp="2q3152lky2u2c" />
              </div>
              <span className="mt-8 block h-3.5 w-28 rounded-full bg-brand-line" aria-hidden="true" data-id="element-164" data-mp="34rx7o348fevk" />
              <span className="sr-only" data-id="element-165" data-mp="2zt2rl8xng4f5">
                Platzhalter – hier folgt eine Rückmeldung einer Lehrkraft.
              </span>
            </article>)}
        </div>
      </Reveal>
    </section>;
}